import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import api from '@/lib/axios';
import type { EntidadesPagina, EntidadesResumen, TipoEntidadBuscable } from '@/types/tareas';

const STALE_MS = 30_000;
export const ENTIDADES_POR_PAGINA = 8;

/** Conteos por tipo y sugerencias ordenadas por cercanía a `referencia` (ISO) o a hoy. */
export function useEntidadesResumen(pacienteId: string | undefined, referencia?: string | null) {
  return useQuery<EntidadesResumen>({
    queryKey: ['tareas', 'entidades', 'resumen', pacienteId, referencia ?? null],
    queryFn: () => api.get('/api/tareas/entidades/resumen', {
      params: { pacienteId, ref: referencia || undefined },
    }).then(r => r.data),
    enabled: !!pacienteId,
    staleTime: STALE_MS,
    retry: false,
  });
}

/** Lista paginada ("cargar más") de un tipo de entidad del paciente, con búsqueda de texto. */
export function useEntidadesLista(pacienteId: string | undefined, tipo: TipoEntidadBuscable, q: string, enabled = true) {
  return useInfiniteQuery<EntidadesPagina>({
    queryKey: ['tareas', 'entidades', 'lista', pacienteId, tipo, q],
    queryFn: ({ pageParam }) => api.get('/api/tareas/entidades', {
      params: { pacienteId, tipo, q: q || undefined, page: pageParam, limit: ENTIDADES_POR_PAGINA },
    }).then(r => r.data),
    initialPageParam: 1,
    getNextPageParam: ultima => (ultima.page * ultima.limit < ultima.total ? ultima.page + 1 : undefined),
    enabled: enabled && !!pacienteId,
    staleTime: STALE_MS,
    placeholderData: keepPreviousData,
    retry: false,
  });
}
